import { ActivatedRouteSnapshot, CanActivateFn } from "@angular/router";

export const redirectToGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  window.location.href = route.data['redirectUrl'] + window.location.search;
  return false;
}
